export var ApplicationError;
(function (ApplicationError) {
    ApplicationError["generalFailure"] = "Do\u0161lo k chyb\u011B, pros\u00EDm obnovte str\u00E1nku a akci opakujte.";
    ApplicationError["connectionFailure"] = "Chyba p\u0159i komunikaci se serverem. Zkuste to pros\u00EDm znovu.";
    ApplicationError["resourceNotFound"] = "Str\u00E1nka neexistuje.";
})(ApplicationError || (ApplicationError = {}));
